import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import React from "react";
import SourceDropdown from "./SourceDropdown";
import { hasSiteKeyword } from "../utils";
import { t } from "i18next";
import classNames from "classnames";
function SelectWorkspace(props) {
  var siteOptions = props.siteOptions,
    setSelectedSource = props.setSelectedSource,
    selectedSource = props.selectedSource,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    disabled = props.disabled;
  var _hasSiteKeyword = hasSiteKeyword();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("z-40", _defineProperty({}, className, !!className))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex relative items-center border justify-between space-x-12 border-gray-700 rounded-lg text-base px-5 py-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "whitespace-nowrap"
  }, t(_hasSiteKeyword ? "site_key" : "workspace_key"), ":"), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(SourceDropdown, {
    options: siteOptions,
    onChange: setSelectedSource,
    selectedOption: selectedSource,
    className: "w-full",
    optionClassName: "w-full",
    isBottomAligned: true,
    disabled: disabled,
    isWorkspace: true
  }))));
}
export default SelectWorkspace;